import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromTabs from '../reducers/tabs.reducer';

export const selectTabsState = createFeatureSelector<fromTabs.TabsState>('tabs');

export const selectTabs = createSelector(selectTabsState, fromTabs.selectAll);
